<template>
  <form-element :horizontal="true" :style="{ 'max-width': '700px', margin: '0 auto' }">
    <fieldset class="k-form-fieldset">
      <div v-if="kendoForm.visited &&
              kendoForm.errors &&
              kendoForm.errors.VALIDATION_SUMMARY" class="k-messagebox k-messagebox-error">
        {{kendoForm.errors.VALIDATION_SUMMARY}}
      </div>
      <field
          :name="'email'"
          :type="'email'"
          :component="'loginPage'"
          :label="emailMessage"
          :validator="emailValidator"
      >
        <template v-slot:loginPage="{ props }">
          <forminput
              v-bind="props"
              @change="props.onChange"
              @input="handleChange(props)"
              @blur="props.onBlur"
              @focus="props.onFocus"
              @keydown.enter="handleSubmit($event)"
          />
        </template>
      </field>
      <field
          :name="'password'"
          :type="'password'"
          :component="'loginPage'"
          :label="passwordMessage"
          :validator="passwordValidator"
      >
        <template v-slot:loginPage="{ props }">
          <forminput
              v-bind="props"
              @change="props.onChange"
              @input="handleChange(props)"
              @blur="props.onBlur"
              @focus="props.onFocus"
              @keydown.enter="handleSubmit($event)"
          />
        </template>
      </field>
    </fieldset>
    <div class="k-form-buttons">
      <KButton @click="clear">
        {{ cancelMessage }}
      </KButton>
      <KButton
          type="submit"
          :theme-color="'primary'"
          :disabled="!kendoForm.allowSubmit"
      >
        {{ loginMessage }}
      </KButton>
    </div>
  </form-element>
</template>
<script>
import { Field, FormElement } from "@progress/kendo-vue-form";
import { Button } from "@progress/kendo-vue-buttons";
import FormInput from "../ProfileComponents/FormInput.vue";
import { provideLocalizationService } from "@progress/kendo-vue-intl";

import {
  emailValidator,
  passwordValidator,
  firstNameValidator
} from "../../assets/validators";
export default {
  components: {
    field: Field,
    "form-element": FormElement,
    forminput: FormInput,
    KButton:Button
  },
  inject: {
    kendoForm: { default: {} },
    kendoLocalizationService: { default: null },
  },
  props: {
    onSubmit: {
      type: Function,
      required: false,
      default: () => {}
    },
  },
  data: function () {
    return {
      emailValidator: emailValidator,
      passwordValidator: passwordValidator,
      firstNameValidator: firstNameValidator,
      email: null,
      password: null
    };
  },
  computed: {
    emailMessage() {
      return provideLocalizationService(this).toLanguageString(
          "email",
          "Email"
      );
    },
    passwordMessage() {
      return provideLocalizationService(this).toLanguageString(
          "password",
          "Password"
      );
    },
    cancelMessage() {
      return provideLocalizationService(this).toLanguageString(
          "cancel",
          "Cancel"
      );
    },
    loginMessage() {
      return provideLocalizationService(this).toLanguageString(
          "login",
          "Login"
      );
    },
  },
  methods: {
    clear() {
      this.kendoForm.onFormReset();
    },

    handleChange(prop) {
      if(prop.type === 'email') {
        this.email = prop.value;
      }

      if(prop.type === 'password') {
        this.password = prop.value;
      }
    },

    handleSubmit(event) {
      event.preventDefault();

      if(this.password && this.email && this.kendoForm.allowSubmit) {
        this.onSubmit({
          email: this.email,
          password: this.password
        });
      }
    }
  },
};
</script>
<style scoped>
.k-form-buttons {
  justify-content: center;
}
</style>